export const MOCK_SEGURADORAS = [
  "YELUM SEGUROS S.A",
  "HDI SEGUROS S/A",
  "ALLIANZ SEGUROS S/A",
];
